import {CategoryKeyEnum} from '#apollo/schema';
import {ImpactLevel} from '#constant/impactLevel';

export const ImpactLevelDotsMap = {
  [ImpactLevel.high]: [1, 2, 3],
  [ImpactLevel.medium]: [1, 2],
  [ImpactLevel.low]: [1],
};

export const ImpactLevelLabelMap = {
  [ImpactLevel.high]: 'High',
  [ImpactLevel.medium]: 'Med',
  [ImpactLevel.low]: 'Low',
};

export const CategoryNameMap = {
  [CategoryKeyEnum.Diet]: 'Diet',
  [CategoryKeyEnum.Fitness]: 'Fitness',
  [CategoryKeyEnum.Habits]: 'Habits',
  [CategoryKeyEnum.Mental]: 'Mental',
  [CategoryKeyEnum.Sleep]: 'Sleep',
  [CategoryKeyEnum.You]: 'You',
  [CategoryKeyEnum.Research]: 'Research',
};
